import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { StaffOrderDetailFacade } from './detail/staff-order-detail.facade';
import { StaffOrderDetailHeaderComponent } from './detail/staff-order-detail-header.component';
import { StaffOrderDetailNextActionComponent } from './detail/staff-order-detail-next-action.component';
import { StaffOrderDetailKeyInfoComponent } from './detail/staff-order-detail-key-info.component';
import { StaffOrderDetailManagerPanelComponent } from './detail/staff-order-detail-manager-panel.component';
import { StaffOrderDetailMoverPanelComponent } from './detail/staff-order-detail-mover-panel.component';
import { StaffOrderDetailWarehousePanelComponent } from './detail/staff-order-detail-warehouse-panel.component';
import { StaffOrderDetailTimelineComponent } from './detail/staff-order-detail-timeline.component';
import { StaffOrderDetailTechnicalDetailsComponent } from './detail/staff-order-detail-technical-details.component';
import { StaffOrderDetailWalletCardComponent } from './detail/staff-order-detail-wallet-card.component';

@Component({
  selector: 'lib-staff-order-detail',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [StaffOrderDetailFacade],
  imports: [
    TranslateModule,
    NgOptimizedImage,
    StaffOrderDetailHeaderComponent,
    StaffOrderDetailNextActionComponent,
    StaffOrderDetailKeyInfoComponent,
    StaffOrderDetailManagerPanelComponent,
    StaffOrderDetailMoverPanelComponent,
    StaffOrderDetailWarehousePanelComponent,
    StaffOrderDetailTimelineComponent,
    StaffOrderDetailTechnicalDetailsComponent,
    StaffOrderDetailWalletCardComponent,
  ],
  templateUrl: './staff-order-detail.component.html',
  styleUrl: './staff-order-detail.component.scss',
})
export class StaffOrderDetailComponent implements OnInit, OnDestroy {
  readonly facade = inject(StaffOrderDetailFacade);

  public ngOnInit(): void {
    this.facade.init();
  }

  public ngOnDestroy(): void {
    this.facade.destroy();
  }
}
